import { type ReactNode, useId } from 'react';

import { Label } from './ui/label';

interface FieldProps {
  label: string;
  hint?: string;
  error?: string;
  required?: boolean;
  children: (id: string) => ReactNode;
}

/** Owns the label-to-control association so no form wires ids by hand. */
export function Field({ label, hint, error, required = false, children }: FieldProps) {
  const id = useId();

  return (
    <div className="group/field flex flex-col gap-2">
      <Label
        htmlFor={id}
        className="text-[13px] font-semibold text-foreground transition-colors duration-150 ease-out group-focus-within/field:text-primary"
      >
        {label}
        {required ? <span className="text-destructive"> *</span> : null}
      </Label>

      {children(id)}

      {error ? <span className="text-xs text-destructive">{error}</span> : null}
      {!error && hint ? <span className="text-xs text-muted-foreground">{hint}</span> : null}
    </div>
  );
}
